import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/kalana.PNG";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I am a passionate Software Engineering student at Cardiff Metropolitan University
            with a keen interest in developing innovative and efficient software solutions. 
            My academic journey has equipped me with a solid foundation in computer science principles, 
            problem-solving skills, and practical experience in various programming languages and frameworks.
              <br />
              <br />Programming Languages:
              <i>
                <b className="purple"> Proficient in Python, Java, C++, and JavaScript. </b>
              </i>
              <br />
              <br />
              Web Development: &nbsp;
              <i>
                <b className="purple"> Experienced with HTML, CSS, and modern JavaScript.</b> frameworks such as {" "}
                <b className="purple">
                React and Angular.
                </b>
              </i>
              <br />
              <br />
              Databases:
<b className="purple"> Skilled in SQL and NoSQL databases,including MySQL</b> and
              <i>
                <b className="purple">
                  {" "}
                  MongoDB
                </b>
              </i>
              &nbsp;
              <i>
                <b className="purple"> </b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Kalana8"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/kalana_kavinda_"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/kalana-kavinda-7011a3269"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/kalana_kavinda__"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
